import { useMemo } from "react";
import { AnalyticsDashboardCharts } from "../components/analytics/AnalyticsDashboardCharts";
import { AnalyticsDateRangeFilter } from "../components/analytics/AnalyticsDateRangeFilter";
import { useAnalyticsDashboard } from "../hooks/useAnalyticsDashboard";
import { useShopCurrency } from "../hooks/useShopCurrency";
import { buildDashboardChartSeriesByMetric } from "../services/analytics.transforms";

export default function AnalyticsDashboardPage() {
  const { dateRange, setDateRange, summary, timeseries, loading, error } =
    useAnalyticsDashboard();
  const { currency: currencyCode, locale: numberLocale } = useShopCurrency();

  const hasChartData = Boolean(summary && timeseries);
  const isInitialLoad = loading && !hasChartData;

  const chartSeriesByMetric = useMemo(
    () =>
      timeseries?.points
        ? buildDashboardChartSeriesByMetric(timeseries.points)
        : null,
    [timeseries]
  );

  return (
    <s-page heading="Analíticas">
      <s-stack direction="block" gap="large-200">
        <AnalyticsDateRangeFilter
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
          disabled={isInitialLoad}
        />

        {isInitialLoad ? (
          <s-section>
            <s-spinner accessibility-label="Cargando analíticas…" />
          </s-section>
        ) : null}

        {!isInitialLoad && error && !hasChartData ? (
          <s-banner
            tone="critical"
            heading="No se pudieron cargar las analíticas"
          >
            {error}
          </s-banner>
        ) : null}

        {error && hasChartData ? (
          <s-banner
            tone="warning"
            heading="No se pudieron actualizar los datos"
          >
            {error}. Mostrando los últimos datos disponibles.
          </s-banner>
        ) : null}

        {summary && chartSeriesByMetric ? (
          <AnalyticsDashboardCharts
            summary={summary}
            chartSeriesByMetric={chartSeriesByMetric}
            currencyCode={currencyCode}
            numberLocale={numberLocale}
          />
        ) : null}
      </s-stack>
    </s-page>
  );
}
